export default "__VITE_ASSET__BTzA$9jz__"